<template>
    <generic-dialog v-model="followersDialog" 
    title="Followers"
    @input="!followersDialog ? $router.replace(`/${$route.params.username}/`) : ''">
        <followers-list :userId="$route.params.username" style="height: 100%"></followers-list>
    </generic-dialog>
</template>
<script>
import genericDialog from "@/components/dialogs/generic-dialog.vue"
import followersList from "@/components/list/list-followers.vue"
export default {
    components: {
        'followers-list': followersList,
        'generic-dialog': genericDialog
    },
    mounted() {
        this.followersDialog = true
    },

    data() {
        return {
            followersDialog: false
        }
    }
}
</script>